import BetsSettingsPartContainerPortrait from "@baseUI/component/settings/BetsSettingsPartContainerPortrait";
import UIFacade from "@baseUI/UIFacade";
import AutospinSettingsPartContainerPortrait from "@baseUI/component/settings/AutospinSettingsPartContainerPortrait";
import InfoSettingsPartContainerPortrait from "@baseUI/component/settings/InfoSettingsPartContainerPortrait";
import SettingsSettingsPartContainerPortrait from "@baseUI/component/settings/SettingsSettingsPartContainerPortrait";
import MenuPopupLayout from "@baseUI/component/layout/MenuPopupLayout";
import UICreatorComponent from "@baseUI/utils/UICreatorComponent";

export default class MenuPopupLayoutPortrait extends MenuPopupLayout {

    constructor() {
        super()
    }

    setParametersSizePosition(){
        this.param = {
            shadowRect: {x: -600, y: -100, width: 1200, height: 2900},
            panelPopupPosition: {x: -500, y: 100},
            closeBtnPosition: {x: 1000, y: 100},
            panelBtnPosition: {x: 0, y: 10},
            listButtonsPosition: {ax: 150, bx: 130, ay: 0, by:0},
            panelAdditionalPosition: {x: 20, y: 300}
        }

        this.paramPageCommon = {
            captionPosition: [490, 0]
        }

    }

    createImplementationMenu(panelPopup){
        const panelAdditional = UICreatorComponent.addContainer(panelPopup, this.param.panelAdditionalPosition)

        this.betPopup = new BetsSettingsPartContainerPortrait(this.paramPageCommon)
        panelAdditional.addChild(this.betPopup)
        this.betPopup.visible = true

        this.autospinPopup = new AutospinSettingsPartContainerPortrait(this.paramPageCommon)
        panelAdditional.addChild(this.autospinPopup)
        this.autospinPopup.visible = false

        this.infoPopup = new InfoSettingsPartContainerPortrait()
        panelAdditional.addChild(this.infoPopup)
        this.infoPopup.visible = false

        this.settingsPopup = new SettingsSettingsPartContainerPortrait(this.paramPageCommon)
        panelAdditional.addChild(this.settingsPopup)
        this.settingsPopup.visible = false

        this.panelAdditional = panelAdditional
    }

    updateSize(uiModelView){
        super.updateSize(uiModelView)
        this.panelBtn.y = -50 - uiModelView.shiftY
        this.panelBtn.x = 910 + uiModelView.shiftX
        this.panelBtn.y = -150 - uiModelView.shiftY
        this.panelAdditional.x = 850 + uiModelView.shiftX
        this.panelAdditional.y = 70 - uiModelView.shiftY
        this.closeBtn.x = 1850 + uiModelView.shiftX
        this.closeBtn.y = -200 - uiModelView.shiftY
    }
}